import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { AdminQueueView, type QueueFilters } from '@/features/ticket-list/AdminQueueView'
import { AdminGuard } from '@/components/admin-guard'

function str(v: unknown): string | undefined {
  return typeof v === 'string' && v ? v : undefined
}

function Queue() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: '/admin/' })
  return (
    <AdminQueueView
      filters={search}
      onChange={next => navigate({ search: next as never, replace: true })}
    />
  )
}

export const Route = createFileRoute('/admin/')({
  // Filters live in the URL so queue views are shareable/bookmarkable.
  validateSearch: (raw: Record<string, unknown>): QueueFilters => ({
    status: str(raw.status),
    priority: str(raw.priority),
    assignee: str(raw.assignee),
    companyId: str(raw.companyId),
    q: str(raw.q),
    sort: str(raw.sort),
    page: Number(raw.page) > 1 ? Math.trunc(Number(raw.page)) : undefined,
  }),
  component: () => (
    <AdminGuard>
      <Queue />
    </AdminGuard>
  ),
})
